import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlServidor } from '../util/url-servidor';
import { Paginador } from '../api/dto/paginacao/paginador';
import { ClienteRetorno } from '../api/dto/cliente-retorno';

@Injectable({
    providedIn: 'root',
})
export class ClienteRetornoService {

    constructor(private http: HttpClient) { }

    private url: string = UrlServidor.URL_BASE + 'clientes-retornos/';

    listarRetornosPorEmpresaPaginado(empresaId?: number, numeroPagina?: number,
         tamanhoPagina?: number, ordenacao?: string, inputBusca?: string, dataInicio?: Date, dataFinal?: Date): Observable<Paginador<ClienteRetorno>> {

        let params = new HttpParams();
        if(tamanhoPagina) {
            params = params.set('tamanho', tamanhoPagina);
        }
        if(ordenacao) {
            params = params.set('sort', ordenacao);
        }
        if(inputBusca) {
            params = params.set('busca', inputBusca);
        }
        if(dataInicio) {
            params = params.set('dataInicio', dataInicio.toISOString());
        }
        if(dataFinal) {
            params = params.set('dataFim', dataFinal.toISOString());
        }
        
        return this.http.get<Paginador<ClienteRetorno>>(this.url + 'empresa/' + empresaId 
            + '/numero-pagina/' + numeroPagina, {params});
    }



}